import { createFileRoute } from '@tanstack/react-router';

import { ReCaptchaProvider } from '#features/form';
import { SecuritySettings } from '#modules/user/features/profile/components/SecuritySettings';

export const Route = createFileRoute(
  '/{-$locale}/_layout/_dashboard/_authed/dashboard/settings/_settings/security'
)({
  component: RouteComponent,
  ssr: false,
});

// Капча нужна смене почты и пароля: обе мутации её проверяют.
function RouteComponent() {
  return (
    <ReCaptchaProvider>
      <SecuritySettings />
    </ReCaptchaProvider>
  );
}
